import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, Button, IconButton, Icon } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

const AnnouncementPopup = ({ open, onClose, announcements = [] }) => (
  announcements && announcements.length > 0 ? (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          width: 700,
          maxWidth: '90vw',
          minHeight: 240,
          maxHeight: '80vh',
          borderRadius: 8,
          padding: 0,
        },
      }}
    >
      <DialogTitle style={{ paddingRight: 48}}>
        {/* Use material icon ligature so materialicon: 'campaign' works */}
        <Icon style={{ fontSize: 30, color: '#f00a0aff', marginRight: 12 }}>campaign</Icon>
        <label style={{ fontSize: 23, position : 'absolute', color: 'rgba(0,0,0,0.87)' }}><b>Announcements</b></label>
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers style={{ padding: 16, overflowY: 'auto', maxHeight: 'calc(80vh - 96px)' }}>
        {announcements && announcements.length > 0 ? (
          announcements.map((a, idx) => (
            <div key={idx} style={{ marginBottom: 24 }}>
              <Typography variant='h7'><b>{a.Subject}</b></Typography>
              {/* Render HTML body and preserve line breaks; use component="div" so inner HTML renders correctly */}
              <Typography
                component="div"
                style={{ lineHeight: 1.5, color: 'rgba(0,0,0,0.87)' }}
                dangerouslySetInnerHTML={{ __html: a.Body }}
              />
            </div>
          ))
        ) : (
          <Typography variant="body1" gutterBottom>
            No active announcements at this time.
          </Typography>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={onClose}
            style={{ minWidth: 160, maxWidth: 200 }}
          >
            I Understand
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  ) : null
);

export default AnnouncementPopup;
